<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Subscription Info</li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="myBusiness" class="account-settings-container layout-top-spacing">
  <div class="account-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <app-package-panel *ngIf="myBusiness.licenseType != 'marketer'" [myBusiness]="myBusiness" [lang]="lang" [merchantPackage]="myBusiness.merchantPackage" [paylinkSubscription]="myBusiness.paylinkSubscription"></app-package-panel>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
